
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';

// Create a root first
const root = createRoot(document.getElementById("root")!);

// Then render your app wrapped in BrowserRouter
root.render(
  <BrowserRouter basename="/">
    <App />
  </BrowserRouter>
);
